import {AbstractException} from "frontend-core/dist/Exceptions/AbstractException";

export class ValidationException extends AbstractException {
    constructor(public readonly message: string) {
        super("Validation exception", message);
    }
}
